import styled from "styled-components";

export const ImageFieldWrapper = styled.div`
  width: 100%;
  aspect-ratio: 1;
  position: relative;
  border: 3px dashed var(--border-color);
  border-radius: ${(props) => (props.$rounded ? '100%' : '8px')};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: var(--theme-color-secondary);
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  transition: all ease-in-out 0.3s;
  max-width: ${(props) => props.size}px;

  &:not(.disabled):hover {
    border-color: var(--theme-color-primary);

    svg {
        color: var(--theme-color-primary);
    }
  }

  &.disabled {
    border: 1px solid var(--border-color);
  }

  svg {
    width: 50%;
    max-width: 50px;
    height: auto;
    color: var(--border-color);
    transition: all ease-in-out 0.3s;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ImageInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
`;